let counter = 0 // see explanation of requestIndex below

export default query => (dispatch, getState) => {

  // requestIndex encodes the order at which queries are sent to the server in order
  // to ensure that a long-running query, whose response arrives after a more recent
  // and relevant query has completed, doesn't override the latest query results
  const requestIndex = counter++

  if (!query || query.length <= 1) {
    return dispatch({ type: 'LOAD_TYPEAHEAD', requestIndex, query, data: [] });
  }


  dispatch({ type: 'LOADING_TYPEAHEAD' });

  const { token, wtRegion } = getState();
  const url = `${process.env.REACT_APP_API_URL}/securityfund/typeahead/`;
  fetch(`${url}?q=${query}&wtRegion=${wtRegion}`, {
    headers: {
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => d.json())
    .then(data => {
      dispatch({
        type: 'LOAD_TYPEAHEAD',
        requestIndex, query,
        data: Array.isArray(data) ? data : [],
      });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'LOAD_TYPEAHEAD', requestIndex, query, data: [] });
    });
};



// WEBPACK FOOTER //
// ./src/actions/query-api/typeahead.js